// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Tsp_","colMin":"styles_colMin__2P5FF"};